module.exports = __webpack_public_path__ + "static/index/assets/img/icon_1.ae183f8b.png";